//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      inputCode: '',
      shareCode: '',
      palace: null,
      anchors: [],
      share: null,
      codeLoaded: false
    }
  },
  computed: {
    posterStyle () {
      const bg = this.palace && (this.palace.backgroundImage || this.palace.background_image)
      const color = (this.palace && (this.palace.themeColor || this.palace.theme_color)) || '#1E3A5F'
      if (bg) {
        return {
          backgroundImage: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.45)), url(' + bg + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      }
      return { background: 'linear-gradient(135deg,' + color + ',#4a90e2)' }
    }
  },
  created () {
    const code = this.$route.query.code
    if (code) {
      this.inputCode = code
      this.load()
    }
  },
  methods: {
    load () {
      const code = (this.inputCode || '').trim()
      if (!code) {
        this.$toast && this.$toast('请输入分享码')
        return
      }
      this.$ajax.get(this.$api.mpShareInfo + '?code=' + encodeURIComponent(code)).then(r => {
        this.codeLoaded = true
        this.share = (r && r.share) || null
        this.palace = (r && r.palace) || null
        this.anchors = (r && r.anchors) || []
        this.shareCode = (this.share && this.share.shareCode) || code
      }).catch(e => {
        this.codeLoaded = true
        this.palace = null
        this.$toast && this.$toast(e.message || '分享码无效')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/share.vue